module.exports = __webpack_public_path__ + "img/aq.2c772185.svg";